import React from "react"
import "./Pdp.css"

const Product = props => (
    <div className="PDP-Device">
    <h2>{props.device}</h2>
    <img
      className="PDP-Image"
      src={props.image}
      alt={props.device}
    />
  </div>
)

export default Product